import { Notification } from '../interfaces/Notification';

export default function isClientSpacePromotionId(notifications: Notification[]): boolean {
  return notifications?.some((notification) => notification.id === 'IA_CLIENT_SPACE');
}
